import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  margin-bottom: 20px;
`;
const Wrapper = styled.div`
  min-height: 150px;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  box-shadow: ${({ edit }) =>
    !edit
      ? '4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff'
      : '0px 0px 0px 200vmax rgba(0,0,0,0.8)'};
  border-radius: 5px;
  border: none !important;
  background-color: ${COLORS.WHITE};
  z-index: ${({ edit }) => (!edit ? 'unset' : '999')};
  position: ${({ edit }) => (!edit ? 'unset' : 'relative')};
  pointer-events: ${({ edit }) => (!edit ? 'unset' : 'relative')};
`;

const ErrorMsg = styled.span`
  color: red;
  text-transform: capitalize;
  font-size: 18px;
  font-weight: bold;
  animation: glow 1s ease-in-out infinite alternate;

  @keyframes glow {
    from {
      text-shadow: 0 0 8px #fff, 0 0 16px #fff, 0 0 24px #ca060c,
        0 0 32px #ca060c, 0 0 40px #ca060c, 0 0 48px #ca060c, 0 0 56px #ca060c;
    }

    to {
      text-shadow: 0 0 4px #fff, 0 0 8px #ff0000, 0 0 12px #ff0000,
        0 0 16px #ff0000, 0 0 20px #ff0000, 0 0 24px #ff0000, 0 0 28px #ff0000;
    }
  }
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${COLORS.BODY_TEXT};
  font-weight: 600;
  padding: 10px 15px;
  justify-content: space-between;
  h3 {
    margin: 0;
    display: flex;
    align-items: center;
  }

  > div {
    display: flex;
    grid-gap: 15px;
    button {
      font-size: 11px;
      padding: 2px 2px;
      text-transform: capitalize;
      :first-child {
        background-color: ${COLORS.BLACK};
        color: ${COLORS.WHITE};
        :hover {
          background-color: ${COLORS.BLACK};
          opacity: 0.8;
        }
      }
      :nth-child(2) {
        background-color: #d43f3a;
        color: ${COLORS.WHITE};
        :hover {
          background-color: #d43f3a};
          opacity: 0.8;
        }
      }
  }
  }`;

const Panel = styled.div`
  padding: 15px;
`;

const OrderInfo = styled.ul`
  padding: 0;
  margin: 0;
  li {
    display: grid;
    column-gap: 20px;
    margin-bottom: 12.5px;
    align-items: center;
    @media (min-width: 470px) {
      grid-template-columns: 0.3fr 1fr;
    }
    > span {
      line-height: 1.42857143;
      :first-child {
        width: auto;
        font-weight: 700;
        @media (min-width: 768px) {
          float: left;
          width: 160px;
          overflow: hidden;
          clear: left;
          text-align: right;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        @media (min-width: 992px) {
          min-width: 99px;
        }
      }
      p {
        margin: 0;
      }
    }
  }
`;

const Status = styled.div`
  flex-direction: column;
  position: relative;
  justify-content: center;
  border-radius: 4px;
  padding: 3px 12.5px;
  border: 1px solid var(--status-color);
  width: auto;
  min-width: 175px;
  text-align: center;
  display: inline-flex;
  flex: 0;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #fff;
  h5 {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: bold;
    margin: 0;
    font-size: 11px;
    color: inherit;
  }
  span {
    font-size: 12px;
  }
`;

const OrderAction = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  width: 100%;
  > div {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    border-top: 1px solid #f3f3f3;
    padding-top: 15px;
    Button {
      margin-left: 14px;
      text-transform: capitalize;
      font-size: 14px;
      line-height: 1.42857;
      padding: 6px 12px;
      text-align: center;
      white-space: nowrap;
      font-weight: normal;
      :first-child {
        margin-left: 0;
      }
      :hover {
        opacity: 0.8;
      }
    }
  }
`;

const FulfillmentDisclaimer = styled.h1`
  text-align: right;
  color: #d43f3a;
  font-size: 14px;
`;

export {
  Container,
  Wrapper,
  Heading,
  Panel,
  OrderInfo,
  Status,
  OrderAction,
  FulfillmentDisclaimer,
  ErrorMsg,
};
